/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Totp_Uri_InvalidInputs */



/**
* | output |
* | --- |
* | "Invalid authenticator setup. Please reload the page and try again." |
*
* @param {Auth_Totp_Uri_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_totp_uri_invalid = /** @type {((inputs?: Auth_Totp_Uri_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Totp_Uri_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültige Authenticator-Einrichtung. Bitte lade die Seite neu und versuche es erneut.")
	return /** @type {LocalizedString} */ ("Invalid authenticator setup. Please reload the page and try again.")
});